<template>
    <div>
        <!--search content-->
        <div class="search-container">
            <!-- banner-->
            <div class="banner">           
                <BarreRecherche @submit-search="submitSearch" />
            </div>
            <!--fin banner-->
        </div>
        <!--Recherche resuktat-->
        <RechecherResult :refresh="refresh" @watch-refresh="watchRefresh" />
    </div>
</template>

<script>
import BarreRecherche from '@/components/recherche/BarreRecherche.vue';
import RechecherResult from '@/views/recherche/RechecherResultPage.vue'

export default {
    name: "SearchPage",
    components: { BarreRecherche, RechecherResult },
    data() {
        return {
            refresh: false
        }
    },
    methods: {
        submitSearch() {
            this.refresh = true
        },
        watchRefresh() {
            this.refresh = false
        }
    }, 
    mounted() {
        // console.log(this.refresh)    
    },
}
</script>
<style lang="scss" scoped>
    @import "@/scss/helpers/mixins";
    @import "@/scss/helpers/variables";

.search-container {
    max-width: 100%;
    margin-right: auto;
    background: #283861;
    padding: 30px 20px;
    border-bottom-left-radius: 50% 5px;
    border-bottom-right-radius: 50% 5px;
    overflow: hidden;
    background-image: url('@/assets/images/patern_blue.jpg');
    background-size: cover;

    @include min($lg) {
        padding: 3em 0;
        border-bottom-left-radius: 50% 30px;
        border-bottom-right-radius: 50% 30px;
    }

    .banner {
        max-width: 1024px;
        margin: auto;
        input[type=search]{
            border: 0;
        }
        
    }
}
</style>